export const GET_CAL_HISTORY_DATA = "GET_CAL_HISTORY_DATA";
export const CAL_HISTORY_DATA_FETCHED = "CAL_HISTORY_DATA_FETCHED";
export const CAL_HISTORY_DATA_FETCHING_FAILED = "CAL_HISTORY_DATA_FETCHING_FAILED";
